import { injectable } from "tsyringe";

@injectable()
export class AssetLoader {
  private loadedAssets: string[] = [];

  createScript(
    src: string,
    type = "text/javascript",
    isAsync = true,
    node: HTMLElement | string | null = null,
    parameters: Record<string, string> = {},
    datasets: Partial<DOMStringMap> = {},
  ): HTMLScriptElement {
    const script: HTMLScriptElement = document.createElement("script");

    script.async = isAsync;
    script.defer = !isAsync;
    script.type = type;
    script.src = src;

    Object.keys(parameters).forEach((parameter) => {
      script.setAttribute(parameter, parameters[parameter]);
    });

    Object.keys(datasets).forEach((dataset) => {
      script.dataset[dataset] = datasets[dataset];
    });

    if (typeof node === "string") {
      const temp = document.getElementsByTagName("script")[0];

      temp.parentNode?.insertBefore(script, temp);
    } else {
      const temp = node || document.body;

      temp.append(script);
    }

    return script;
  }

  /**
   * Injects <script> tag
   */
  loadScript(
    src: string,
    type = "text/javascript",
    isAsync = true,
    node: HTMLElement | string | null = null,
    parameters: Record<string, string> = {},
    datasets: Partial<DOMStringMap> = {},
  ): Promise<unknown> {
    return new Promise((resolve, reject) => {
      if (this.loadedAssets.includes(src)) {
        return resolve(null);
      }
      const script: HTMLScriptElement = this.createScript(
        src,
        type,
        isAsync,
        node,
        parameters,
        datasets,
      );

      script.onload = resolve;
      script.onerror = reject;
    }).then((payload) => {
      this.loadedAssets.push(src);

      return payload;
    });
  }
}
